import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeE',
    component: () => import(/* webpackChunkName: "homeE" */ '@/views/homeE.vue')
  },
  {
    path: '/catalog',
    name: 'productListE',
    component: () => import(/* webpackChunkName: "productListE" */ '@/views/productListE.vue')
  },
  {
    path: '/topup/:id',
    name: 'payCheckoutE',
    component: () => import(/* webpackChunkName: "payCheckoutE" */ '@/views/payCheckoutE.vue')
  },
  {
    path: '/mobile',
    name: 'mobileTopupE',
    component: () => import(/* webpackChunkName: "mobileTopupE" */ '@/views/mobileTopupE.vue')
  },
  {
    path: '/checkout/:gameId/:orderNo',
    name: 'payConfirmE',
    component: () => import(/* webpackChunkName: "payConfirmE" */ '@/views/payConfirmE.vue')
  },
  {
    path: '/payResult',
    name: 'payResultE',
    component: () => import(/* webpackChunkName: "payResultE" */ '@/views/payResultE.vue')
  },
  // 法务三页正文复用 A/B/C 共用组件，legalE 只负责 E 的排版与左侧目录
  {
    path: '/privacy',
    name: 'rprivacyE',
    meta: { doc: 'privacy' },
    component: () => import(/* webpackChunkName: "legalE" */ '@/views/legalE.vue')
  },
  {
    path: '/tos',
    name: 'reulaE',
    meta: { doc: 'tos' },
    component: () => import(/* webpackChunkName: "legalE" */ '@/views/legalE.vue')
  },
  {
    path: '/conduct',
    name: 'ractionE',
    meta: { doc: 'conduct' },
    component: () => import(/* webpackChunkName: "legalE" */ '@/views/legalE.vue')
  }
]

const routerE = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default routerE
